import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as actions from '../actions'
import Form from '../components/ambassadors/join/form'
import Login from '../components/ambassadors/join/login'
import Signup from '../components/ambassadors/join/signup'
import HasAccount from '../components/ambassadors/join/hasAccount'
import Success from '../components/ambassadors/join/success'
import Layout from '../components/layout/Layout'
import meta from '../constants/meta'
import styles from '../constants/styles'

const Step = (step) => {
  switch (step) {
    case 'login':
      return <Login />
    case 'signup':
      return <Signup />
    case 'form':
      return <Form />
    case 'success':
      return <Success />
    default:
      return <HasAccount />
  }
}

const Join = ({ step }) => (
  <Layout specialPage meta={meta.ambassadorJoin}>
    <Main>
      <Image></Image>
      <TitleContainer>
        <Title>Join Now</Title>
        <Subtitle>Ambassadors Program</Subtitle>
      </TitleContainer>
      {Step(step)}
    </Main>
  </Layout>
)

Join.propTypes = {
  step: PropTypes.string.isRequired
}

const mapStateToProps = (state) => ({
  step: state.ambassadors.all.step
})

const mapDispatchToProps = (dispatch) => ({
  submitForm: ({ form }) => {
    dispatch(actions.ambassadors.submitForm({ form }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Join)

const Main = styled.main`
  width: 100%;
  max-width: 100vw;
`

const Image = styled.div`
  width: 100%;
  height: 150px;
  background-image: url('https://res.cloudinary.com/abillionveg/image/upload/v1575445684/influencers_landing/remi-walle-UOwvwZ9Dy6w-unsplash_1_1.jpg');
  background-size: 100%;
  background-position: top;
  @media (max-width: 900px) {
    height: auto;
    background-size: 220%;
  }
`

const TitleContainer = styled.div`
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.h1`
  color: ${styles.colors.darkGrey};
  font-size: 3em;
  @media (max-width: 600px) {
    font-size: 2.5em;
  }
`

const Subtitle = styled.h2`
  color: ${styles.colors.darkGrey};
  font-size: 2em;
  @media (max-width: 600px) {
    font-size: 1.5em;
  }
`
